/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BudgetOverviewYearDto } from '../../models/budget-overview-year-dto';

export interface GetBudgetOverviewPerYear$Params {
}

export function getBudgetOverviewPerYear(http: HttpClient, rootUrl: string, params?: GetBudgetOverviewPerYear$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BudgetOverviewYearDto>>> {
  const rb = new RequestBuilder(rootUrl, getBudgetOverviewPerYear.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BudgetOverviewYearDto>>;
    })
  );
}

getBudgetOverviewPerYear.PATH = '/budget-management/overview-per-year';
